import { VOUCHERS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import vouchersTypes from '../../constants/vouchersTypes'
import { axios } from '../../services'

// 1 delete
const delete_voucher_request = () => {
  return {
    type: vouchersTypes.publish.request
  }
}

const delete_voucher_success = (response) => {
  return {
    type: vouchersTypes.publish.success,
    payload: response.data
  }
}

const delete_voucher_failure = (messages) => {
  if (messages.constructor === Array) {
    window.showSnackbar('error', messages.join("\n"))
  }
  return {
    type: vouchersTypes.publish.failure,
    payload: messages
  }
}

const delete_voucher = (voucher_id, page=1, per_page=10, filters={}, sort="", order="") => {
  return function(dispatch) {
    // Before Request
    dispatch( delete_voucher_request() )
    const reqParams = {
      page: page,
      per_page: per_page,
      sort: sort,
      order: order,
      filters: filters
    }
    // Request
    axios.delete(
      formatRoute(VOUCHERS_ROUTES.destroy, {id: voucher_id}),
      {
        params: reqParams
      }
    ).then( response => {
      window.showSnackbar('success', 'The voucher has been permanently deleted.')
      dispatch( delete_voucher_success(response) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error deleting voucher"]
      }
      dispatch( delete_voucher_failure( errors ) )
    })
  }
}

export {delete_voucher}



// WEBPACK FOOTER //
// ./src/js/actions/vouchers/delete.js